import {
  SELECT_ARTBOARD,
  SET_PREVIEW_DURATION,
  SET_PREVIEW_CURRENT_TIME,
  UPDATE_STORY_MUSIC_PLAYBACK,
  SET_PREVIEW_STATE,
  SET_TRANSITION_STATE,
} from "./types";

export const updateStoryMusicPlayback = (payload) => ({
  type: UPDATE_STORY_MUSIC_PLAYBACK,
  payload,
});

export const selectArtboard = (id = null, idx = null) => ({
  type: SELECT_ARTBOARD,
  id,
  idx,
});

export const setPreviewDuration = (duration) => ({
  type: SET_PREVIEW_DURATION,
  payload: duration,
});

export const setPreviewCurrentTime = (time) => ({
  type: SET_PREVIEW_CURRENT_TIME,
  payload: time,
});

export const setPreviewState = (state) => ({
  type: SET_PREVIEW_STATE,
  payload: state,
});

export const setTransitionState = (from, to, transition, progress) => ({
  type: SET_TRANSITION_STATE,
  payload: {
    from,
    to,
    transition,
    progress,
  },
});
